import React from 'react';
import { Helmet } from 'react-helmet-async';

interface IMetaTagsProps {
    lang: string;
    title: string;
}

export const MetaTags = (props: IMetaTagsProps) => {
    return (
        <Helmet>
            <title lang={props.lang}>{props.title}</title>
        </Helmet>
    );
};
